import angular from 'angular';
import uiRouter from 'angular-ui-router';
import component from './account.component';
import config from './account.config';
import { AccountMovesModule } from './moves';
import AccountProfileModule from './profile/profile';
import AccountPasswordModule from './password/password';

export default angular
  .module('app.account', [
    uiRouter,
    AccountProfileModule.name,
    AccountPasswordModule.name,
    AccountMovesModule.name,
  ])
  .config(config)
  .directive('uappAccount', component);
